import styled from 'styled-components';

export const StyledLabel = styled.label`
  margin: 20px 0 10px;
`;

export const ModalFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  max-width: 600px;
  min-width: 300px;
  padding: 30px;
  max-height: 80vh;
  overflow-y: auto;

  /* The modal sizes to its content from tablet up. Field messages break the form's inline
     labels and inputs into short lines, which narrowed the dialog; a set width keeps it the
     same with or without them (100px is the modal's own margin and padding). */
  ${({ theme }) => theme.media.tabletPortraitUp`
    width: min(600px, calc(100vw - 100px));
  `}
`;
